/**
 * UI experience toggle — user preference for V1 vs V2 screens (when a V2 route exists).
 * Lives outside `src/v2` so layouts and routes can depend on it without importing V2 internals.
 * Persisted in localStorage; default V2 ON when unset.
 */
import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const STORAGE_KEY = "v2_ui_preference_v2";

// function readPreference() {
//   try {
//     const v = localStorage.getItem(STORAGE_KEY);
//     if (v === null || v === undefined || v === "") return true;
//     return v === "true" || v === "1";
//   } catch {
//     return true;
//   }
// }

function readPreference() {
  return true;
}

function writePreference(value) {
  try {
    localStorage.setItem(STORAGE_KEY, value ? "true" : "false");
  } catch {
    // ignore localStorage errors (e.g. private mode)
  }
}

const V2ToggleContext = createContext({
  preferV2: true,
  setPreferV2: () => {},
});

export function V2ToggleProvider({ children }) {
  const [preferV2, setPreferV2State] = useState(() => readPreference());

  const setPreferV2 = useCallback((value) => {
    setPreferV2State((prev) => {
      const next = typeof value === "function" ? value(prev) : !!value;
      writePreference(next);
      return next;
    });
  }, []);

  const value = useMemo(() => ({ preferV2, setPreferV2 }), [preferV2, setPreferV2]);

  return <V2ToggleContext.Provider value={value}>{children}</V2ToggleContext.Provider>;
}

export function useV2Toggle() {
  const ctx = useContext(V2ToggleContext);
  if (!ctx) {
    return { preferV2: true, setPreferV2: () => {} };
  }
  return ctx;
}

export default V2ToggleContext;
